import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { QuotationItemDto } from 'tekkeys-common';

export interface QuotationState extends EntityState<QuotationItemDto> {}

export const quotationAdapter: EntityAdapter<QuotationItemDto> = createEntityAdapter<QuotationItemDto>();
